import React from 'react';

const Terms: React.FC = () => {
    return (
        <div className="container mx-auto px-4 py-8 max-w-4xl text-gray-300">
            <h1 className="text-3xl font-serif text-tudor-gold mb-6 tracking-widest uppercase">Terms of Service</h1>

            <div className="space-y-6 text-sm leading-relaxed">
                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">1. Acceptance of Terms</h2>
                    <p>By accessing and using Tudor Chess ("the Service"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.</p>
                </section>

                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">2. Description of Service</h2>
                    <p>Tudor Chess is a strategy game platform comprising various game modes including Skirmish, Campaign, and Ranked Play. We reserve the right to modify, suspend, or discontinue any part of the Service at any time.</p>
                </section>

                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">3. User Accounts</h2>
                    <p>You may need to register for an account to access certain features. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
                </section>

                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">4. User Conduct</h2>
                    <p>You agree not to modify, adapt, or hack the Service or modify another website so as to falsely imply that it is associated with the Service. Cheating, exploiting bugs, or using automation software (bots) is strictly prohibited.</p>
                </section>

                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">5. Disclaimer of Warranties</h2>
                    <p>The Service is provided on an "as is" and "as available" basis. We disclaim all warranties of any kind, whether express or implied, including but not limited to the implied warranties of merchantability and fitness for a particular purpose.</p>
                </section>

                <section>
                    <h2 className="text-xl text-tudor-gold mb-2">6. Contact</h2>
                    <p>For any questions regarding these Terms, please contact us at support@tudorchess.com.</p>
                </section>
            </div>
        </div>
    );
};

export default Terms;
